//
// Utilities
import debug from "debug";
const log = debug("google-maps-api");

//
// Dependencies
import GoogleMapsApiLoader from './google-maps-api-loader.js';
import { GOOGLE_API_KEY } from './config';

//
// Config
const GOOGLE_API_OPTIONS = {
    libraries: ['places'],
    apiKey: GOOGLE_API_KEY
};

//
// Exports
/**
 * @type {Promise.<google>}
 */
export default GoogleMapsApiLoader(GOOGLE_API_OPTIONS);




// WEBPACK FOOTER //
// ./client/src/vendor/google-maps-api/index.js